import { FilterOptionItem } from '@src/design-system/filter-new';
import type { TRenderOptionItemCtx } from '../../types/filter-config';
import type { TLabel } from '@src/shared/types/label';

export function LabelFilterOptionItem({
  selected,
  item,
  onToggle,
}: TRenderOptionItemCtx<TLabel>) {
  return (
    <FilterOptionItem
      selected={selected}
      onClick={onToggle}
    >
      <span
        className='px-2 py-1 rounded-md'
        style={{ background: item.hexa_color }}
      >
        {item.name}
      </span>
    </FilterOptionItem>
  );
}
